export const leadsActionTypes = {
	GET_LEADS_STATS: "GET_LEADS_STATS",
	GET_ALL_LEADS: "GET_ALL_LEADS",
	GET_SINGLE_LEAD: "GET_SINGLE_LEAD",
};
